import { Table } from "../../features/Table";
import { type Factor, factor_columns } from "./columns";
import { FilterFactors } from "./filter";

const client = "legacy-quantilia";
const table_name = "factors";

export const FactorsTable = () => {
  return (
    <Table<Factor, Factor>
      label="Factors"
      client={client}
      table_name={table_name}
      columns={factor_columns}
      filter={<FilterFactors />}
      disable_translations_request={true}
    />
  );
};
